import { Dialog } from '@base-ui-components/react/dialog'
import { cn } from '../../utils/cn'

export function DialogDescription({ className, ...props }: DialogDescription.Props) {
  return <Dialog.Description className={cn('text-sm text-gray-500', className)} {...props} />
}

export namespace DialogDescription {
  export interface Props extends Dialog.Description.Props {}
}
